import React from "react";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core";
import { Spinner } from "@components";
import { useBookingHospitalityGetQuery } from "@graphql";
import { BookingAccommodationSection } from "./BookingAccommodationSection";
import { BookingTravelSection } from "./BookingTravelSection";
import { WeekYear } from "@bonliva-crm/common";

type Props = {
  bookingId: string;
  bookingGroupId: string;
  consultantName: string;
  week: WeekYear;
};

export function BookingHospitality(props: Props) {
  const { bookingId } = props;
  const classes = useStyles({});

  const { data, error, loading } = useBookingHospitalityGetQuery({
    variables: { bookingId, week: { Week: props.week.Week, Year: props.week.Year } },
    fetchPolicy: "cache-and-network"
  });

  if (loading && !data) {
    return <Spinner fullHeight />;
  }

  if (error) {
    throw error;
  }

  return (
    <div className={classes.root}>
      <BookingAccommodationSection
        bookingId={props.bookingId}
        bookingGroupId={props.bookingGroupId}
        consultantName={props.consultantName}
        data={data.bookingHospitality}
        week={props.week}
      />

      <BookingTravelSection
        bookingId={props.bookingId}
        bookingGroupId={props.bookingGroupId}
        data={data.bookingHospitality}
        week={props.week}
      />
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    padding: 16
  },

  item: {
    width: "66%"
  },

  documentsWrapper: {
    padding: 16
  },

  accom: {
    marginTop: 16
  }
}));
